/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class AssignedDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      AssignedDrivers: [],
      printInfo: [],
      finalPlanDate: '',
      aggregationAssigned: {}
    }
  }

  changeDropDown(data) {
    this.setState({
      AssignedDrivers: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  onResultFetched(data) {
    this.setState({
      AssignedDrivers: data
    })
  }

  componentDidMount() {
    sessionStorage.removeItem('params')
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    const {planId, planDate} = this.props.match.params

    sessionStorage.setItem('planId', planId)

    sessionStorage.setItem('params', `planId=${planId}`)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_BYPLAN}?export=true&planId=${planId}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))

        if (response.data.error === null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            AssignedDrivers: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            finalPlanDate: jMoment(Number(this.convertDigit(planDate))).format('jYYYY/jMM/jDD'),
            aggregationAssigned: response.data.object.aggregation
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        //alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_BYPLAN}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_BYPLAN}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))

        if (response.data.error === null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            aggregationAssigned: response.data.object.aggregation
          })
        }
      })
      .catch((error) => {
        //alert(JSON.stringify(error))
      })
  }

  exportPrint = async () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    await this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {AssignedDrivers} = this.state
    let excelColumns = [
      {title: 'رساننده', value: 'deliveryPackId'},
      {title: 'شناسه فاکتور', value: 'invoiceId'},
      {title: 'قیمت کل', value: 'afterDiscountAmount'},
      {title: 'قیمت نهایی', value: 'totalAmount'},
      {title: 'قیمت قابل پرداخت', value: 'payableAmount'},
      {title: 'آدرس', value: 'address'},
      {title: 'نام خریدار', value: 'buyerName'}
    ]

    let excelURL = `${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_BYPLAN}?export=true&` + sessionStorage.getItem('params')
    let {planDateFrom, planDateTo} = this.props.match.params
    let printCol = [
      'ردیف',
      'رساننده',
      'اتومبیل',
      'کل',
      'فعال',
      'شروع شده',
      'تحویل در بازه',
      'تحویل خارج از بازه',
      'تمام شده',
      'برگشتی',
      'مرجوعی',
      'تخصیص مجدد'
    ]

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={'رساننده ها انتصابی در تاریخ : ' + this.state.finalPlanDate}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={12}
              rightColSpan={6}
              centerColSpan={1}
              leftColSpan={5}
              centerSection={''}
              rightSection={'بازه زمانی : ' + planDateFrom + ' تا ' + planDateTo}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((drivers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{drivers.driver.name} </td>
                  <td>
                    {drivers.car.name +
                      ' ' +
                      'ایران' +
                      drivers.car.plateNumber +
                      ' - ' +
                      ' (' +
                      drivers.car.plateText +
                      ') ' +
                      'کد ماشین : ' +
                      drivers.car.code}
                  </td>
                  <td>{drivers.totalCount}</td>
                  <td>{drivers.activeCount}</td>
                  <td>{drivers.startCount}</td>
                  <td>{drivers.inCount}</td>
                  <td>{drivers.outCount}</td>
                  <td>{drivers.finishCount}</td>
                  <td>{drivers.returnNotSeenCount}</td>
                  <td>{drivers.returnRejectCount}</td>
                  <td>{drivers.returnReAssignCount}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={3}>مجموع</td>
                <td>{this.state.aggregationAssigned.totalCount}</td>
                <td>{this.state.aggregationAssigned.activeCount}</td>
                <td>{this.state.aggregationAssigned.startCount}</td>

                <td>{this.state.aggregationAssigned.inCount}</td>
                <td>{this.state.aggregationAssigned.outCount}</td>

                <td>{this.state.aggregationAssigned.finishCount}</td>
                <td>{this.state.aggregationAssigned.returnNotSeenCount}</td>
                <td>{this.state.aggregationAssigned.returnRejectCount}</td>
                <td>{this.state.aggregationAssigned.returnReAssignCount}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش رساننده های انتصابی در : ' + this.state.finalPlanDate + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'driver.name'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'code'}
                field={'car.code'}
                title={'کد خودرو'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalCount'}
                field={'totalCount'}
                title={'کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activeCount'}
                field={'activeCount'}
                title={'فعال'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'startCount'}
                field={'startCount'}
                title={'شروع شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'inCount'}
                field={'inCount'}
                title={'تعداد در بازه'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'outCount'}
                field={'outCount'}
                title={'تعداد خارج بازه'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'finishCount'}
                field={'finishCount'}
                title={'تمام شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'returnNotSeenCount'}
                field={'returnNotSeenCount'}
                title={'برگشتی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'returnRejectCount'}
                field={'returnRejectCount'}
                title={'مرجوعی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'returnReAssignCount'}
                field={'returnReAssignCount'}
                title={'تخصیص مجدد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>رساننده های انتصابی</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_BYPLAN}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  selectStatus={false}
                  printComponent={this.printTable}
                  execelUrl={excelURL}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="detailsInfoTable">
              <ul>
                <li>رساننده های انتصابی در تاریخ : {this.state.finalPlanDate}</li>
                <li>
                  بازه زمانی :‌{planDateFrom} تا {planDateTo}
                </li>
              </ul>
            </div>

            <div style={AssignedDrivers.length == '0' ? {display: 'none'} : {display: 'block'}}>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>
                      <span>ردیف</span>
                    </td>
                    <td>
                      <span>رساننده</span>
                    </td>
                    <td>
                      <span>اتوموبیل</span>
                    </td>
                    <td>
                      <span>تعداد کل</span>
                    </td>
                    <td>
                      <span>تعداد فعال</span>
                    </td>
                    <td>
                      <span>تعداد شروع شده</span>
                    </td>
                    <td>
                      <span> تحویل در بازه</span>
                    </td>
                    <td>
                      <span>تحویل خارج از بازه</span>
                    </td>
                    <td>
                      <span>تعداد تمام شده</span>
                    </td>
                    <td>
                      <span>تعداد برگشتی</span>
                    </td>
                    <td>
                      <span>تعداد مرجوعی</span>
                    </td>
                    <td>
                      <span>تعداد تخصیص مجدد</span>
                    </td>

                    <td>
                      <span>فاکتور ها</span>
                    </td>
                    <td>
                      <span>کالا ها</span>
                    </td>
                    <td>
                      <span>ویرایش رساننده</span>
                    </td>
                    <td>
                      <span>ویرایش فاکتور ها</span>
                    </td>
                  </tr>
                  {this.state.AssignedDrivers.map((drivers, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{drivers.driver.name} </td>
                      <td>
                        {drivers.car.name +
                          ' ' +
                          'ایران' +
                          drivers.car.plateNumber +
                          ' - ' +
                          ' (' +
                          drivers.car.plateText +
                          ') ' +
                          'کد ماشین : ' +
                          drivers.car.code}
                      </td>
                      <td>{drivers.totalCount}</td>
                      <td>{drivers.activeCount}</td>
                      <td>{drivers.startCount}</td>
                      <td>{drivers.inCount}</td>
                      <td>{drivers.outCount}</td>
                      <td>{drivers.finishCount}</td>
                      <td>{drivers.returnNotSeenCount}</td>
                      <td>{drivers.returnRejectCount}</td>
                      <td>{drivers.returnReAssignCount}</td>
                      <td>
                        <Link
                          to={`/DriverFactor/${drivers.dispatchId}/${drivers.driver.name}/${
                            this.props.match.params.planDate
                          }`}
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <Link
                          target="_blank"
                          to={`/ProductPlanFromDispatch/${drivers.dispatchId}/${drivers.driver.name}/${
                            this.props.match.params.planDate
                          }`}
                        >
                          <img src={require('../../image/product.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <Link
                          to={`/editAssignedDriver/${drivers.dispatchId}/driver=${drivers.driver.personId}/car=${
                            drivers.car.carId
                          }`}
                        >
                          <img src={require('../../image/driver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`/EditFactorDrivers/${drivers.dispatchId}/driver=${drivers.driver.personId}/${
                            drivers.driver.name
                          }/${this.props.match.params.planId}`}
                        >
                          <img src={require('../../image/signature.svg')} alt="" />
                        </Link>
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td colSpan={3}>مجموع</td>
                    <td>{this.state.aggregationAssigned.totalCount}</td>
                    <td>{this.state.aggregationAssigned.activeCount}</td>
                    <td>{this.state.aggregationAssigned.startCount}</td>

                    <td>{this.state.aggregationAssigned.inCount}</td>
                    <td>{this.state.aggregationAssigned.outCount}</td>

                    <td>{this.state.aggregationAssigned.finishCount}</td>
                    <td>{this.state.aggregationAssigned.returnNotSeenCount}</td>
                    <td>{this.state.aggregationAssigned.returnRejectCount}</td>
                    <td>{this.state.aggregationAssigned.returnReAssignCount}</td>
                    <td colSpan={4} />
                  </tr>
                </tbody>
              </table>
              {/*<div className="paginationWrapp">*/}
              {/*<Page defaultCurrent={1} total={this.state.lengthProducts}*/}
              {/*onResultFetched={this.onResultFetched.bind(this)}*/}
              {/*url={REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_BYPLAN}*/}
              {/*urlParams={urlParams}/>*/}
              {/*</div>*/}
            </div>
          </div>

          <div className="notFound" style={AssignedDrivers.length == '0' ? {display: 'block'} : {display: 'none'}}>
            <img src={require('../../image/notFound.svg')} alt="" />
            <p>موردی یافت نشد</p>
          </div>
        </div>
      </div>
    )
  }
}

export default AssignedDrivers
